import axios from "./axios";
import { v4 as uuidv4 } from "uuid";

const logWhyDie = async (error: string, uuid: string): Promise<void> => {
  try {
    await axios.get(`${window.location.origin}/logWhyDie`, {
      params: {
        trackerId: window.EDRONE_CONTEXT.trackerId,
        agentId: window.EDRONE_CONTEXT.user.agentId,
        uid: uuid,
        error,
        path: encodeURIComponent(window.location.pathname),
      },
    });
  } catch (e) {
    console.error("logWhyDie error", e);
  }
};

const pingUser = async (uuid: string): Promise<void> => {
  const fadeBox = document.querySelector(".fade-box") as HTMLElement;
  if (getComputedStyle(fadeBox).display !== "flex") {
    try {
      const jwt = localStorage.getItem("jwt");
      const url = new URL(`${window.location.origin}/ping`);
      url.searchParams.set("workspace", window.EDRONE_CONTEXT.trackerId.toString());
      url.searchParams.set("agentId", window.EDRONE_CONTEXT.user.agentId.toString());
      url.searchParams.set("uid", uuid);

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          ...(jwt && { Authorization: `Bearer ${jwt}` }),
        },
        redirect: "follow",
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      if (response.status === 401 || response.status === 403) {
        const o = { status: response.status, msg: response.statusText };
        await logWhyDie(JSON.stringify(o), uuid);
        localStorage.removeItem("jwt");
        window.location.href = "/login";
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.token) {
        localStorage.setItem("jwt", data.token);
      }

      const integrationStatusEl = document.querySelector("#integration-status");
      const currentStatus =
        integrationStatusEl?.getAttribute("data-integration-status") !== "undefined"
          ? integrationStatusEl?.getAttribute("data-integration-status")
          : true;

      if (
        (window.location.pathname === "/settings/integration" || window.location.pathname === "/dashboard") &&
        !currentStatus &&
        data?.isIntegrationCompleted
      ) {
        window.location.reload();
      }

      window.EDRONE_CONTEXT.isIntegrationCompleted = data?.isIntegrationCompleted;
      window.EDRONE_CONTEXT.whatsappIntegrated = data?.whatsappIntegrated;
      window.EDRONE_CONTEXT.tracker = {
        ...window.EDRONE_CONTEXT.tracker,
        platform: data.platform,
        showOnboardings: data.showOnboardings,
        trackerBranding: data.trackerBranding,
        trackerSmsSender: data.trackerSmsSender,
      };
      window.EDRONE_CONTEXT.trackerConfiguration = data.trackerConfiguration;

      const suspended = data.isSuspended;
      const suspendReasonId = data.suspendModificationReasonId;
      const infoBox = document.querySelector("#info-box") as HTMLElement;

      if (
        getComputedStyle(fadeBox).display !== "flex" &&
        suspended &&
        !["/settings/billing", "/support", "/settings/plans_and_pricing"].includes(window.location.pathname)
      ) {
        infoBox?.setAttribute("agentissuspended", "1");

        if (suspendReasonId === "1") {
          document.querySelector(".suspended-box-administrative")?.classList.add("show");
        }
        if (suspendReasonId === "2") {
          document.querySelector(".suspended-box-trial")?.classList.add("show");
        }
        if (suspendReasonId === "3") {
          document.querySelector(".suspended-box-billing-plan-exceeded")?.classList.add("show");
        }
      } else {
        infoBox?.setAttribute("agentissuspended", "");

        if (suspendReasonId === "1") {
          document.querySelector(".suspended-box-administrative")?.classList.remove("show");
        }
        if (suspendReasonId === "2") {
          document.querySelector(".suspended-box-trial")?.classList.remove("show");
        }
        if (suspendReasonId === "3") {
          document.querySelector(".suspended-box-billing-plan-exceeded")?.classList.remove("show");
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 302) {
        const redirectLocation = error.response.headers.location;
        if (redirectLocation) {
          window.location.href = redirectLocation;
        }
      } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        const o = { status: error.response.status, msg: error.response };
        logWhyDie(JSON.stringify(o), uuid);
        localStorage.removeItem("jwt");
        window.location.href = "/login";
      } else {
        console.error("pingUser error", error);
      }
    }
  }
};

export const startPingUser = (): (() => void) => {
  if (window.location.pathname === "/app/pingdom") return () => {};

  const uuid = uuidv4();
  const boundPingUser = () => pingUser(uuid);

  const interval = setInterval(boundPingUser, 15000);
  window.addEventListener("focus", boundPingUser);

  boundPingUser();

  return () => {
    clearInterval(interval);
    window.removeEventListener("focus", boundPingUser);
  };
};
